// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"9b39fb78","348":"e92d3758","571":"059978f9","924":"037d255e"}[chunkId] + ".chunk.js";
};